import { Dispatch, FC, ReactNode, SetStateAction, useRef, useState } from "react";
import {
  Box,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
  GridCheckIcon,
  GridDensity,
  Toolbar,
  ToolbarButton,
} from "@mui/x-data-grid-pro";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import __ from "src/utils/Translations";

export interface TableSettings {
  density: GridDensity;
}

interface DataGridToolbarProps {
  id: string;
  settings: TableSettings;
  showFilters: boolean;
  setSettings: Dispatch<SetStateAction<TableSettings>>;
  setShowFilters: Dispatch<SetStateAction<boolean>>;
  actionButton?: ReactNode;
}

const DENSITY_OPTIONS: { label: string; value: GridDensity }[] = [
  { label: "Widok standardowy", value: "standard" },
  { label: "Widok komfortowy", value: "comfortable" },
];

const DataGridToolbar: FC<DataGridToolbarProps> = ({
  id,
  settings,
  showFilters,
  setSettings,
  setShowFilters,
  actionButton,
}) => {
  const settingsMenuTriggerRef = useRef<HTMLButtonElement>(null);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);

  return (
    <Toolbar>
      <Box sx={{ flexGrow: 1 }} />

      {actionButton}

      <Tooltip title={__("Filtry")}>
        <ToolbarButton
          onClick={() => setShowFilters((value: boolean) => !value)}
        >
          {showFilters ? <FilterAltOffIcon /> : <FilterAltIcon />}
        </ToolbarButton>
      </Tooltip>
      <Tooltip title={__("Ustawienia")}>
        <ToolbarButton
          ref={settingsMenuTriggerRef}
          id={`${id}-settings-menu-trigger`}
          aria-controls={`${id}-settings-menu`}
          aria-haspopup="true"
          aria-expanded={settingsMenuOpen ? "true" : undefined}
          onClick={() => setSettingsMenuOpen(true)}
        >
          <SettingsIcon />
        </ToolbarButton>
      </Tooltip>
      <Menu
        id={`${id}-settings-menu`}
        anchorEl={settingsMenuTriggerRef.current}
        open={settingsMenuOpen}
        onClose={() => setSettingsMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disableAutoFocusItem
        disableScrollLock
        slotProps={{
          list: {
            "aria-labelledby": `${id}-settings-menu-trigger`,
          },
        }}
      >
        {DENSITY_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() =>
              setSettings((prev) => ({ ...prev, density: option.value }))
            }
          >
            <ListItemIcon>
              {settings.density === option.value && (
                <GridCheckIcon fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Toolbar>
  );
};

export default DataGridToolbar;
